import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { API_URL } from 'src/app/shared/constants/apiurl-constants';
import { Engagement } from 'src/app/shared/models/engagement/engagement.model';
import { SessionService } from 'src/app/shared/session-service/session.service';
import { LoadingIndicatorService } from '@kpmg-tax/ui';

@Injectable({
  providedIn: 'root',
})
export class EmployeeInformationService {
  eiTableDataFiltered: any; // Results shown as rows on table. This will change when search field is populated by ngx-datatable.
  employeeInformationApiCallData: any; // Hold the API Call Data
  employeeNumberListFromTable: any;
  clientUsers:any;
  filteredCount: number;
  initialCount: number;
  employeeTableRefresh = new BehaviorSubject({});
  engagementRefresh = new BehaviorSubject(<Engagement>{});
  refreshEmployees = this.employeeTableRefresh.asObservable();
  engagementID: number;
  isAssigned: boolean;
  employeeInformationApiData = new BehaviorSubject({});
  employeeInformationDataRefresh = this.employeeInformationApiData.asObservable();
  canFilterEmployeeData = new BehaviorSubject(<boolean>(null));
  canFilteremployeeDataTesult = this.canFilterEmployeeData.asObservable();
  assignedEmployee: boolean = false;
  constructor(public sessionService: SessionService,
    private _loader: LoadingIndicatorService) {
    this.engagementID = this.sessionService.engagementIdFocus;
  }
  storeAssigned(assigned: boolean) {
    this.isAssigned = assigned;
  }
  // Refresh Table through observable
  refreshTable() {
    this.employeeTableRefresh.next(true);
  }

  refreshEngagement(engagement: Engagement) {
    this.engagementRefresh.next(engagement);
  }

  // Populate the data table grid
  public employeeList = (engagementId?: any) => {
    // API call to get information
    if (engagementId) {
      this.engagementID = engagementId;
    }

    if (engagementId > 0) {
      this.engagementID = engagementId;
    } else if (Number(this.sessionService.getSession('engagementId')) > 0) {
      this.engagementID = Number(
        this.sessionService.getSession('engagementId'),
      );
    }
    this._loader.display(true);
    this.sessionService
      .apiUrlGet(
        API_URL.GETEMPLOYEESBYENGAGEMENT + '?engagementId=' + this.engagementID,
      )
      .subscribe(
        data => {
          this.employeeInformationApiCallData = data;
          this.employeeInformationApiData.next(data);
          this.employeeNumberListFromTable = this.employeeInformationApiCallData.result.map(
            result => result.employeeNumber,
          );
          this.eiTableDataFiltered = this.employeeInformationApiCallData.result;
          this.filteredCount = this.eiTableDataFiltered.length;
          this.initialCount = this.employeeNumberListFromTable.length;
          this.assignedEmployee =
            this.eiTableDataFiltered.filter(x => x.assigned === true).length > 0;
          this._loader.display(false);
          this.canFilterEmployeeData.next(true);
        },
        error => {
          this._loader.display(false);
          console.log('Error in pulling Engagement ID Employee Info:');
          console.log(error);
        },
      );
  }
  postEmpData(data) {
    return this.sessionService.apiUrlPost(
      API_URL.ADDEMPLOYEE,
      data,
    );
  }
  updateEmpData(data) {
    return this.sessionService.apiUrlPost(
      API_URL.UPDATEEMPLOYEE,
      data,
    );
  }
  deleteEmpRec(data) {
    return this.sessionService.apiUrlPost(
      API_URL.DELETEEMPLOYEE,
      data,
    );
  }

  GetClientUsers(clientId: number) {
    return this.sessionService.apiUrlGet(
      API_URL.CLIENT.GET_ALL_USER + '?clientId=' + clientId,
    );
  }

  

  public getImportFileStatus(engagementId) {
    return this.sessionService.apiUrlGet(
      API_URL.GET_IMPORT_FILE_STATUS + '?engagementId=' + engagementId,
    );
  }

  getLocations()
  {
    return this.sessionService.apiUrlGet(
      API_URL.GETLOCATIONS
    );
  }

}
